const initialState = {
  volume: 0.7, // 0.0 to 1.0
  desktopEnabled: true,
  connectionStatus: 'disconnected', // disconnected, connecting, connected, error
  sseEnabled: true,
  autoRefreshEnabled: true,
  autoRefreshInterval: 30, // seconds
};

export default function notifications(state = initialState, action) {
  switch (action.type) {
    case 'SET_NOTIFICATION_PREFERENCES': {
      return {
        ...state,
        ...action.preferences
      };
    }

    case 'SET_CONNECTION_STATUS': {
      return {
        ...state,
        connectionStatus: action.status
      };
    }

    default:
      return state;
  }
}
